var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLitecoinSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.002 472C384.002 476.418 380.42 480 376.002 480H136.002C113.91 480 96.002 462.092 96.002 440V243.508L9.846 263.781C9.221 263.938 8.596 264 8.002 264C4.377 264 1.096 261.531 0.221 257.844C-0.811 253.531 1.877 249.219 6.158 248.219L96.002 227.078V40C96.002 35.594 99.596 32 104.002 32S112.002 35.594 112.002 40V223.312L278.156 184.219C282.656 183.187 286.781 185.875 287.781 190.156C288.812 194.469 286.125 198.781 281.844 199.781L112.002 239.742V440C112.002 453.199 122.803 464 136.002 464H376.002C380.42 464 384.002 467.582 384.002 472Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitecoinSign);
export default __webpack_public_path__ + "static/media/litecoin-sign.9170497f0eb7d83b96d5608073ec9b14.svg";
export { ForwardRef as ReactComponent };